import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=1cde30b1&scoped=true&"
import script from "./Sector.vue?vue&type=script&lang=js&"
export * from "./Sector.vue?vue&type=script&lang=js&"
import style0 from "./Sector.vue?vue&type=style&index=0&id=1cde30b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde30b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging.appraisal.owiwi.co.uk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cde30b1', component.options)
    } else {
      api.reload('1cde30b1', component.options)
    }
    module.hot.accept("./Sector.vue?vue&type=template&id=1cde30b1&scoped=true&", function () {
      api.rerender('1cde30b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/Sector.vue"
export default component.exports